import { Component, Inject, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit {

  constructor(private http: HttpService, private snackBar: SnackbarService, @Inject(MAT_DIALOG_DATA) private parentData: any, private dialog: MatDialogRef<FileUploaderComponent>) { }
  epods_data: any = new FormData();
  ngOnInit(): void {

  }

  selectDocs() {
    document.getElementById('epods').click();
  }

  fileChanged(event: any,) {
    if (event.target.files.length) {
      const ins = event.target.files.length;
      for (let x = 0; x < ins; x++) {
        if (this.parentData.type == 'attachment') {
          this.epods_data.append('attachments', event.target.files[x]);
        } else if (this.parentData.type == 'invoice_attachment') {
          this.epods_data.append('attachments', event.target.files[x]);
          let shipments = this.parentData.payload._id;
          this.epods_data.append(`shipments`, shipments);

          this.epods_data.append('plant_code', this.parentData.payload.plant_code);
        } else if (this.parentData.type === 'additional_charge') {
          this.epods_data.append('additional_charge_attachment', event.target.files[x]);
        } else
          this.epods_data.append('epod', event.target.files[x]);
      }
      if (this.parentData.type === 'additional_charge' && this.parentData.commercial_invoice_num) {
        this.epods_data.append('commercial_invoice_num', this.parentData.commercial_invoice_num);
      }
    }
  }

  upload() {
    if (this.parentData.type=='attachment') {
      this.http.upload(this.parentData.payload.url + this.parentData.payload._id, this.epods_data,1).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.epods_data = new FormData();
          this.snackBar.openSnackBar('Attachment Upload Successfully');
          this.dialog.close(response);
        }
      },
        (err) => {
          this.epods_data = new FormData();
          this.snackBar.openSnackBar(err.error.message, '', 'err');
        });
    } else  if (this.parentData.type == 'invoice_attachment') {
      this.http.upload(this.parentData.payload.url, this.epods_data, 1).subscribe((response: any) => {
        if (response.statusCode == 200) {

          this.epods_data = new FormData();
          this.snackBar.openSnackBar('Attachment Upload Successfully');
          this.dialog.close(response);
        }
      },
        (err) => {
          this.epods_data = new FormData();
          this.snackBar.openSnackBar(err.error.message, '', 'err');
        });
    } else if (this.parentData.type === 'additional_charge') {
      const uploadUrl = this.parentData.url + this.parentData.path_param_id;
      this.http.upload(uploadUrl, this.epods_data).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.epods_data = new FormData();
          this.snackBar.openSnackBar('Additional Charge Attachment Uploaded Successfully');
          this.dialog.close(response);
        }
      },
        (err) => {
          this.epods_data = new FormData();
          this.snackBar.openSnackBar(err.error.message, '', 'err');
          this.dialog.close({ message: err.error.message || 'Upload failed' });
        });
    } else {
      this.http.upload(this.parentData.url + this.parentData._id, this.epods_data).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.epods_data = new FormData();
          this.snackBar.openSnackBar('Epod Upload Successfully');
          this.dialog.close(response);
        }
      },
        (err) => {
          this.epods_data = new FormData();
          this.snackBar.openSnackBar(err.error.message, '', 'err');
        });
    }
  }
}
